import React from 'react'
import mapping from './AddressHPMetaManager.json'
import { selectLocale } from '../../../store/navigation/navigation.selectors'
import MetaTags from '../../seo/MetaTags'
import { useSelector } from 'react-redux'
import { getCountryByLocale } from '../../i18n'
import { insertTranslationArgs } from '../../i18n/T'

const AddressHPMetaManager = () => {
  const locale = useSelector(selectLocale)
  const metaData = mapping[locale]
  const country = getCountryByLocale(locale)

  return (
    <MetaTags
      title={insertTranslationArgs(metaData.title, [country])}
      description={metaData.description}
      alternateLinkPath="/plan"
    />
  )
}

export default AddressHPMetaManager
